// navigationSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NavigationState {
  cameFromCheckout: boolean;
}

const initialState: NavigationState = {
  cameFromCheckout: false,
};

const navigationSlice = createSlice({
  name: 'navigation',
  initialState,
  reducers: {
    setCameFromCheckout(state, action: PayloadAction<boolean>) {
      state.cameFromCheckout = action.payload;
    },
  },
});

export const { setCameFromCheckout } = navigationSlice.actions;
export default navigationSlice.reducer;
